import Text from "@pathwright/ui/src/components/ui/Text"
import { getPrimaryColor } from "@pathwright/ui/src/components/utils/colors"
import { MEDIA_TYPES } from "@pathwright/ux/src/components/filestack/constants"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Select from "react-select"
import { ChooseFileTypeWrapper, SelectWrapper } from "../ui"
import { getAllowedFileOptions } from "../utils"

export const ChooseFileType = ({ currentFileType, onChangeFileType }) => {
  const { tc, t } = useTranslate()
  const allowedFileOptions = [
    ...getAllowedFileOptions(t),
    {
      value: MEDIA_TYPES.LINK,
      label: t("link")
    }
  ]

  return (
    <ChooseFileTypeWrapper>
      <Text.Body style={{ marginRight: "0.5rem", textAlign: "center" }}>
        {tc("Upload")}{" "}
      </Text.Body>
      <SelectWrapper>
        <Select
          onChange={onChangeFileType}
          value={
            allowedFileOptions.find(
              (option) => option.value === currentFileType
            ) || allowedFileOptions[0]
          }
          options={allowedFileOptions}
          styles={{
            control: (baseStyles) => ({
              ...baseStyles,
              width: "100%",
              maxWidth: "250px",
              minWidth: "150px",
              cursor: "pointer"
            }),
            menu: (baseStyles) => ({
              ...baseStyles,
              // Keep menu in-flow (no portal). Portaling to document.body was
              // preventing open/activation inside the blocks editor surface.
              zIndex: 100000000,
              position: "absolute",
              backgroundColor: "white",
              borderRadius: 5,
              border: "1px solid #ddd"
            }),
            menuList: (baseStyles) => ({
              ...baseStyles,
              cursor: "pointer"
            }),
            option: (baseStyles) => ({
              ...baseStyles,
              cursor: "pointer"
            }),
            dropdownIndicator: (baseStyles) => ({
              ...baseStyles,
              cursor: "pointer"
            })
          }}
        />
      </SelectWrapper>
    </ChooseFileTypeWrapper>
  )
}

export default ChooseFileType
